import React from 'react';
import { Box, Typography } from '@mui/material';

import { useThrottle } from '@core/dashboard/hooks/helpers';

import { IBaseReactionItemProps } from './interfaces';
import { useStyles } from './styles';

const BaseReactionItem = ({
  onClick,
  previewImage,
  title,
}: IBaseReactionItemProps) => {
  const classes = useStyles();

  const handleClick = useThrottle(onClick);

  return (
    <Box sx={classes.root} onClick={handleClick}>
      <Box sx={classes.imageWrap}>
        <img src={previewImage} alt={title} />
      </Box>
      <Typography sx={classes.title}>{title}</Typography>
    </Box>
  );
};

export default BaseReactionItem;
